import { render, staticRenderFns } from "./S1.vue?vue&type=template&id=c1d50124&scoped=true&"
import script from "./S1.vue?vue&type=script&lang=js&"
export * from "./S1.vue?vue&type=script&lang=js&"
import style0 from "./S1.vue?vue&type=style&index=0&id=c1d50124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d50124",
  null
  
)

export default component.exports